/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import * as Yup from "yup";

const validations = {
  nameCharacterValidation: Yup.string()
    .max(50, "Maximum 50 characters")
    .matches(/^[a-zA-Z0-9\s]*$/, "Only letters, numbers, and spaces are allowed")
    .required("Name is required"),

  categoryId: Yup.string().required("Category is required"),
  typeId: Yup.string().required("Type is required"),
  cusineId: Yup.string().required("Cuisine is required"),
  ingredients: Yup.string().required("Ingredient is required"),
  preparationTime: Yup.string().required("Preparation Time and type is required"),
  dishType: Yup.string().required("Dish Type is required, Choose Regular or bulk"),

  stringUnit: Yup.string()
    .required("Unit is required")
    .matches(/^[a-zA-Z\s]*$/, "Only letters and spaces are allowed"),

  numericUnit: Yup.number()
    .typeError("Must be a number")
    .required("Unit is required"),

  measurementId: Yup.number().required("Measurement ID is required"),

  amount: Yup.number()
    .required("Price is required")
    .typeError("Price must be a number")
    .test("is-float", "Price must be a float", (value) =>
      /^\d*\.?\d*$/.test(String(value))
    ),

  discount: Yup.number()
    .typeError("Discount must be a number")
    .test("is-float", "Discount must be a float", (value) =>
      /^\d*\.?\d*$/.test(String(value))
    ),

  finalPrice: Yup.number()
    .required("Final Price is required")
    .typeError("Final Price must be a number")
    .test("is-float", "Final Price must be a float", (value) =>
      /^\d*\.?\d*$/.test(String(value))
    ),
};

export const dishSchema = Yup.lazy((values: any) => {
  const measurementId = parseInt(values?.dishvariants?.[0]?.measurementId);
  const isSizeMeasurement = measurementId === 3; // adjust '3' based on your size-based measurement ID

  return Yup.object().shape({
    name: validations.nameCharacterValidation,
    categoryId: validations.categoryId,
    typeId: validations.typeId,
    cuisineId: validations.cusineId,
    ingredients: validations.ingredients,
    preparationTime: validations.preparationTime,
    dishType: validations.dishType,

    dishvariants: Yup.array()
      .of(
        Yup.object().shape({
          unit: isSizeMeasurement
            ? validations.stringUnit
            : validations.numericUnit,
          measurementId: validations.measurementId,
          price: validations.amount,
          discount: validations.discount,
          finalPrice: validations.finalPrice,
        })
      )
      .min(1, "At least one dish variant is required")
      .required("Dish variants are required"),
  });
});
